import {css} from '@emotion/react';
import {colors, fontFamily, fontSize} from 'patient-ping-remedy/packages/theme';

export const globalStyles = css`
  body {
    margin: 0;
    background: ${colors.ash};
    font-family: ${fontFamily.default};
    font-size: ${fontSize.standard};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html {
    font-size: 62.5%; // 62.5% of 16px = 10px
  }

  html, body, #root {
    height: 100%;
    box-sizing: border-box;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  // adjust font size to 1rem = 10px for Remedy alerts
  .remedy-alert {
    font-size: 1rem;
  }

  // improved responsiveness for Remedy components
  #remedySlideInPane > div:last-of-type,
  #modal-content > div[class$="overlay-container"] > div[class$="modal-container"] {
    max-width: 100%;
  }

  // forces icons to have same width as height
  svg[data-icon] {
    width: auto !important;
    aspect-ratio: 1 / 1;
  }

  // substitute styles for DOM mismatch between react-select 4.3 and 5+
  span[id^="react-select"] ~ div[class$="control"] > div:first-of-type {
    display: flex;

    & > span {
      display: flex;
      align-items: center;

      & > div[class$="placeholder"],
      & > div[class$="singleValue"] {
        position: absolute;
      }
    }
  }
`;
